// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/screens/PropertyPortals/components/PortalCard/index.css
// module id = 1882
// module chunks = 0